class Signature {
    public Date: Date;
    public Value: string;
    public UserContactFacetIds: string[];

    constructor(fields?: Partial<Signature>) {
        Object.assign(this, fields);
        this.Value = fields?.Value ?? "";
        this.UserContactFacetIds = fields?.UserContactFacetIds ?? [];
    }
}

export { Signature };
